type Link = {
  translationKey: string,
  location: string,
  roleRequired?: string
}

export const MAIN_LINKS: Link[] = [
  {
    translationKey: 'reservation',
    location: '/reservation',
    roleRequired: 'write_reservation',
  },
  {
    translationKey: 'check_out',
    location: '/checkout',
    roleRequired: 'checkout',
  },
  {
    translationKey: 'check_in',
    location: '/checkin',
    roleRequired: 'checkin',
  },
  {
    translationKey: 'manage',
    location: '/manage',
    roleRequired: 'read_reservation',
  },
  {
    translationKey: 'statistics2',
    location: '/statistics',
    roleRequired: 'statistics',
  },
] as const;

export const SUB_LINKS: Link[] = [
  {
    translationKey: 'faq',
    location: '/faq',
  },
  {
    translationKey: 'customer_service',
    location: '/support',
  },
] as const;
